<template>
	<WebshopLoyalty v-slot="{onSubmit, loading, loyalty, usePointsActive}">
		<div v-if="user?.id && loyalty?.all_points_discount && loyalty?.points?.available" class="checkout-loyalty loyalty-w" :class="{'loading': loading}">
			<div class="checkout-dropdown-title">Vaši loyalty bodovi: <span>{{loyalty.points.available}} bodova</span></div>
			<input type="radio" id="field-use_loyalty_point-1" name="use_loyalty_point" @change="() => onSubmit(true)" :checked="usePointsActive" value="1">
			<label for="field-use_loyalty_point-1">Iskoristi <span><BaseUtilsFormatCurrency :price="loyalty.all_points_discount" /> popusta</span> dobivenih na temelju prikupljenih <span>{{loyalty.points.available}} loyalty bodova</span></label>
			<p>
				<input type="radio" id="field-use_loyalty_point-0" name="use_loyalty_point" @change="() => onSubmit(true)" :checked="!usePointsActive" value="0" >
				<label for="field-use_loyalty_point-0">Nemoj još koristiti popust</label>
			</p>
		</div>
    </WebshopLoyalty>
</template>

<script setup>
	const auth = useAuth();
	const user = computed(() => auth.getUser());
</script>

<style lang="less" scoped>
.checkout-loyalty{
	padding: 30px 40px 0;
	@media (max-width: @t){padding: 25px 30px 0;}
	@media (max-width: @tp){padding: 20px 15px 0;}
	input[type=radio]+label{
		font-size: 16px; line-height: 24px;
		&:before{box-sizing: initial;}
		span{font-weight: bold;}
	}
	p{
		@media (max-width: @t){padding-top: 5px;}
	}
	&.loading{opacity: 0.3; pointer-events: none;}
}
</style>